import React from "react";

import { Button } from "components";
import s from "components/UI/Button/FormButton.module.scss";

import Estados from "pages/miakey/admin/estados/Estados";

export default function RangoModal({
    accesoDetailId, closeModal, service, selectedRow, usuarioId, merchantServicioUsuarioId
}) {
    return (
        <>
            <Estados
                accesoDetailId={accesoDetailId}
                service={service}
                selectedRow={selectedRow}
                usuarioId={usuarioId}
                merchantServicioUsuarioId={merchantServicioUsuarioId}
            />
            <div className={"closeButtonContainer"}>
                <Button
                    className={s.defaultBtn}
                    onClick={closeModal}
                >
                    Cerrar
                </Button>
            </div>

        </>
    );
}